// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__29IWA","dragIcon":"Choice_dragIcon__1hqkK","left":"Choice_left__3eoDd","input":"Choice_input__3tL5G"};